import { render, staticRenderFns } from "./Laskutusasetukset.vue?vue&type=template&id=c8c3a8fe&"
import script from "./Laskutusasetukset.vue?vue&type=script&lang=js&"
export * from "./Laskutusasetukset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDivider,VIcon,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8c3a8fe')) {
      api.createRecord('c8c3a8fe', component.options)
    } else {
      api.reload('c8c3a8fe', component.options)
    }
    module.hot.accept("./Laskutusasetukset.vue?vue&type=template&id=c8c3a8fe&", function () {
      api.rerender('c8c3a8fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Laskutusasetukset.vue"
export default component.exports